import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import LoaderOverlay from "modules/layout/components/LoaderOverlay";
import routes from "routes/routes";

interface RequireAccountsEnabledProps {
  children: React.ReactElement;
}

/**
 * Dark-shipping gate for the H-3a account routes: renders `children` only when
 * the active tenant has `accountsEnabled`; otherwise redirects home.
 *
 * Waits for `configLoaded === true` before deciding (same reasoning as
 * UnavailableServiceRedirect): until the async tenant load resolves the store
 * holds DefaultConfig, and a direct-paste URL would be redirected wrongfully.
 */
const RequireAccountsEnabled: React.FC<RequireAccountsEnabledProps> = ({
  children,
}) => {
  const configLoaded = useSelector(
    (state: RootState) => state.tenantConfig.configLoaded
  );
  const accountsEnabled = useSelector(
    (state: RootState) => state.tenantConfig.config.accountsEnabled === true
  );

  if (!configLoaded) {
    return <LoaderOverlay open={true} />;
  }

  if (!accountsEnabled) {
    return <Navigate to={routes.home} replace />;
  }

  return children;
};

export default RequireAccountsEnabled;
